import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
//Component Imports
import GenericTable from "../../components/table/generic-table";
import TradeTable from "../../components/trade-table-fc/trade-table";
import Card from "../../components/UI/Card/Card";
import Header from "../../common/header/header";
import VSButton from "../../components/vs-button/vs-button";
import { Statuses } from "../../common/helper";
import { callTradeStatusCount } from "../../lookups";
import Loader from "../../components/loader/loader";
import TradeContext from "../../store/tradeState/tradeContext";
import TradeProvider from "../../store/tradeState/tradeProvider";

// Asset Imports
import InvestecImgSrc from "../../assets/investec.png";

//Style Imports
import "./dashboard.css";
import RangeCalendar from "../../components/UI/RangeCalendar/RangeCalendar";
import TradeContainer from "../../components/trade-table/trade/trade-container";

const Dashboard = ({ trades }) => {
  const [datePickerIsOpen, setDatePickerIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [tradeStatusCounts, setTradeStatusCounts] = useState([]);

  const trdCtx = useContext(TradeContext);

  const getStatusCount = (dateSelection) => {
    const startDate = `${dateSelection.startDate.getDate()}-${
      dateSelection.startDate.getMonth() + 1
    }-${dateSelection.startDate.getFullYear()}`;
    const endDate = `${dateSelection.endDate.getDate()}-${
      dateSelection.endDate.getMonth() + 1
    }-${dateSelection.endDate.getFullYear()}`;
    
    setIsLoading(true);
    callTradeStatusCount(startDate, endDate).then((res) => {
      setIsLoading(false);
      setTradeStatusCounts(res);
    });
  };

  return (
    <>
      <Header
        title="Dealer Dashboard"
        subtitle="Welcome to Currency Assist Dealer Dashboard"
      />
      {/* <div className="card">
        <div className="card-header-row">
          <h4 className="card-title">Trade Completion by Bank</h4>
          <RangeCalendar onChange={getStatusCount} />
        </div>
        <div className="card-body">
          <img src={InvestecImgSrc} alt="" className="responsiveImg" />
          <VSButton
            bgColor="#FFFFFF"
            headerColor="#25A9E1"
            buttonColor="#25A9E1"
            subheaderColor="#000000"
            link="/trades/my-trades"
            title={isLoading ? <Loader color="#25A9E1" /> : tradeStatusCounts.reduce((a, b) => a + (b.count || 0), 0)}
            subtitle={isLoading ? "Fetching count..." : "In Progress"}
          />
          <VSButton
            bgColor="#FFFFFF"
            headerColor="#8CC63F"
            buttonColor="#8CC63F"
            subheaderColor="#000000"
            link={`trades/my-trades/?status=${Statuses.bop_completed}`}
            title={isLoading ? <Loader color="#8CC63F" /> : tradeStatusCounts.find((s) => s.status === Statuses.bop_completed)?.count}
            subtitle={isLoading ? "Fetching count..." : "BOP Completed"}
          />
          <VSButton
            bgColor="#FFFFFF"
            headerColor="#F5A623"
            buttonColor="#F5A623"
            subheaderColor="#000000"
            link={`trades/my-trades/?status=${Statuses.bop_uploaded}`}
            title={isLoading ? <Loader color="#F5A623" /> : tradeStatusCounts.find((s) => s.status === Statuses.bop_uploaded)?.count}
            subtitle={isLoading ? "Fetching count..." : "BOP Uploaded"}
          />
          <VSButton
            bgColor="#FFFFFF"
            headerColor="#E1261C"
            buttonColor="#E1261C"
            subheaderColor="#000000"
            link={`trades/my-trades/?status=${Statuses.manual_intervention}`}
            title={isLoading ? <Loader color="#E1261C" /> : tradeStatusCounts.find((s) => s.status === Statuses.manual_intervention)?.count}
            subtitle={isLoading ? "Fetching count..." : "Manual Intervention"}
          />
          <VSButton
            bgColor="#000000"
            headerColor="#8CC63F"
            buttonColor="#8CC63F"
            subheaderColor="#FFFFFF"
            link={`trades/my-trades/?status=${Statuses.bank_completed}`}
            title={isLoading ? <Loader color="#8CC63F" /> : tradeStatusCounts.find((s) => s.status === Statuses.bank_completed)?.count}
            subtitle={isLoading ? "Fetching count..." : "Bank Completed"}
          />
        </div>

       </div> */}

      <Card title="Pending Trades" subtitle="List of clients ready to trade">
        <TradeProvider>
          <GenericTable data={trades ? trades : []} />
        </TradeProvider>
      </Card>
      
    </>
  );
};

Dashboard.propTypes = {
  trades: PropTypes.array,
};

export default Dashboard;